import { PaginationProps } from 'antd';
import GeneralHeader from 'components/common/GeneralHeader';
import AbsenceTypeTable from 'components/tables/absence_type';
import useMember from 'hooks/useMember';
import debounce from 'lodash.debounce';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StaffLeaveAndAbsenceTypes = () => {
  const [state, setState] = useState({
    name: null,
    page_size: '10',
    page: '1',
    count: null,
    currentPage: 1,
  });
  const { name, page_size, page, count, currentPage } = state;
  const navigate = useNavigate();
  const ref = useRef();
  const { absenceTypes, getAbsenceTypesList } = useMember();

  const onChangeInput = (event) => {

    updateSearchValue(event);
  };
  const updateSearchValue = useCallback(
    debounce((event) => {
      setState((pre) => ({
        ...pre,
        name: event,
        page: '1',
      }));
    }, 500),
    [],
  );
  const onChange = (pageNumber) => {
    setState((pre) => ({
      ...pre,
      page: pageNumber,
    }));
  };
  const itemRender: PaginationProps['itemRender'] = (
    _,
    type,
    originalElement,
  ) => {
    if (type === 'prev') {
      return <a className="mr-3">Previous</a>;
    }
    if (type === 'next') {
      return <a className="mr-3">Next</a>;
    }

    return originalElement;
  };
  useEffect(() => {
    getAbsenceTypesList({
      ...(name && { name: name }),
      ...(page && { page: page }),
      ...(page_size && { page_size: page_size }),
    }).then((res) => {
      setState((pre) => ({
        ...pre,
        count: res?.count,
        currentPage: res?.page,
      }));
    });
  }, [name, page]);

  return (
    <div>
      <GeneralHeader
        pageTitle="Staff Leave and Absence Types"
        icon="/icons/staff_leave_icon.svg"
        btnComponent={
          <button
            onClick={() =>
              navigate(
                '/staff_leave_&_absences/staff_leave_and_absence_types/create_a_new_staff_leave_types',
              )
            }
            className="header-button"
            style={{ width: '210px' }}
          >
            <img src="/icons/add_button.svg" alt="button" />
            New absence type
          </button>
        }
        child={
          <div>
            <div style={{ marginTop: '50px', paddingBottom: '100px' }}>
              <section className={'function_container'}>
                <div
                  style={{ background: 'white', padding: '10px 0px 10px 0px' }}
                  className={'function_wrapper'}
                >
                  <div>
                    <AbsenceTypeTable
                      ref={ref}
                      onChangeName={onChangeInput}
                      data={absenceTypes}
                      onChange={onChange}
                      itemRender={itemRender}
                      currentPage={currentPage}
                      count={count}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default StaffLeaveAndAbsenceTypes;
